import { t } from '../i18n'

/** Discreet ✕ shown top-right on every step to abandon the session.
 *
 * Absolutely positioned — the parent must be `relative`. `tone` adapts to the surface:
 * `light` on blue screens, `dark` on white cards. Renders nothing without an `onClick`
 * (e.g. the crash-boundary fallback, which has no session to abandon).
 */
export function CloseButton({
  onClick,
  tone = 'dark',
}: {
  onClick?: () => void
  tone?: 'dark' | 'light'
}) {
  if (!onClick) return null
  const color =
    tone === 'light'
      ? 'text-white/60 hover:text-white'
      : 'text-slate-400 hover:text-slate-600'
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
      aria-label={t('close')}
      className={`absolute right-3 top-3 z-10 flex h-9 w-9 items-center justify-center rounded-full transition ${color}`}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
        <path d="M6 6l12 12M18 6L6 18" />
      </svg>
    </button>
  )
}
